import { defineMessages } from 'react-intl';

const messages = defineMessages({
  scanOrdersButton: {
    defaultMessage: 'Scan Orders',
    description: 'Scan Orders button for batches toolbar',
    id: 'nGcvdm',
  },
  buttonDisabledTooManyOrders: {
    defaultMessage: 'Scan Orders is unavailable when there are more orders than the current page size',
    description: 'Scan Orders button disabled tooltip when batch has more orders than page size',
    id: 'K9A6nW',
  },
});

export default messages;
